import React from 'react';
import CustomModal from '../../../components/customModal/CustomModal';
import { Button } from 'react-bootstrap';

interface ItemNameWarningDialogProps {
    show: boolean;
    onAccept: () => void;
    onCancel: () => void;
    orderItemName: string;
    barcodeItemName: string;
}

const ItemNameWarningDialog = ({ show, onAccept, onCancel, orderItemName, barcodeItemName }: ItemNameWarningDialogProps) => {
    if (!show) return null;

    return (
        <CustomModal
            id="ItemNameWarningModal"
            title="Warning"
            content={
                <div>
                    <p>Ordered item name does not match with scanned barcode item name. Do you want to continue?</p>
                    <ul>
                        <li>Ordered : <strong className='text-primary'>{orderItemName}</strong> </li>
                        <li>Scanned : <strong className='text-secondary'>{barcodeItemName}</strong> </li>
                    </ul>
                    <div className='d-flex gap-2 justify-content-end mt-4'>
                        <Button variant="outline-primary" onClick={onCancel}>Cancel</Button>
                        <Button variant="primary" onClick={onAccept}>Continue</Button>
                    </div>
                </div>
            }
        />
    )
}

export default ItemNameWarningDialog;